import Vue from "vue";
import GoogleSignInButton from "vue-google-identity-login-btn";
import App from "./App.vue";
import router from "@/router";
import store from "./state/store";
import VueRouter from "vue-router";
import Notifications from "vue-notification";
import VueCookies from "vue-cookies";
import VuePrism from "vue-prism";
import VueFormulate from "@braid/vue-formulate";
import PrimeVue from "primevue/config";
import DropdownMenu from "v-dropdown-menu/vue2";
import "v-dropdown-menu/vue2/css";

Vue.use(DropdownMenu);
Vue.use(PrimeVue);

Vue.use(VueRouter);
Vue.use(GoogleSignInButton);
Vue.use(VuePrism);
Vue.use(VueFormulate);
Vue.use(VueCookies, {
  expires: "1d",
  path: "/",
  secure: true,
  sameSite: "Lax",
  httpOnly: true,
});
Vue.use(Notifications, {
  speed: 5000,
  closeOnClick: true,
  position: "bottom right",
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
